// WORK_SHIFT_DAY_TYPES
export const GET_WORK_SHIFT_DAY_TYPES_SUCCESS =
  'GET_WORK_SHIFT_DAY_TYPES_SUCCESS';
export const GET_WORK_SHIFT_DAY_TYPES_ERROR = 'GET_WORK_SHIFT_DAY_TYPES_ERROR';
export const GET_WORK_SHIFT_DAY_TYPES_PENDING =
  'GET_WORK_SHIFT_DAY_TYPES_PENDING';
export const SET_WORK_SHIFT_DAY_TYPES = 'SET_WORK_SHIFT_DAY_TYPES';

// WORK_SHIFTS
export const GET_WORK_SHIFT_SUCCESS = 'GET_WORK_SHIFT_SUCCESS';
export const GET_WORK_SHIFT_ERROR = 'GET_WORK_SHIFT_ERROR';
export const GET_WORK_SHIFT_PENDING = 'GET_WORK_SHIFT_PENDING';
export const SET_WORK_SHIFT = 'SET_WORK_SHIFT';
